import { DotsHorizontal } from '@aktiia/design-system';
import { useState } from 'react';
import { Popover } from 'react-tiny-popover';

import { UserMenuPopover } from './components';
import { IUserMenuProps } from './types';

export const UserMenu = ({ user }: IUserMenuProps) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const handleOnClick = () => {
    setIsPopoverOpen(!isPopoverOpen);
  };

  const handleClose = () => {
    setIsPopoverOpen(false);
  };

  return (
    <div className="flex items-center justify-end cursor-pointer">
      <Popover
        align="end"
        reposition={false}
        padding={8}
        isOpen={isPopoverOpen}
        onClickOutside={handleClose}
        positions={['bottom']}
        content={<UserMenuPopover user={user} />}
      >
        <button onClick={handleOnClick}>
          <DotsHorizontal />
        </button>
      </Popover>
    </div>
  );
};
